import N8nIcon from './Icon.vue';

export default N8nIcon;
export { type IconName, updatedIconSet } from './icons';
